import React from 'react';
import User from "../../../components/pages/grid/User/User";

const UserGridPage = () => {
    return <User />
};

export default UserGridPage;